import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Base = styled.div`
  border: 1px solid black;
  border-radius: 80px;
  cursor: pointer;
  height: 160px;
  position: absolute;
  top: calc(50% - 80px);
  width: 160px;
  z-index: 80;

  &::after {
    border-left: 2px solid black;
    border-top: 2px solid black;
    content: '';
    height: 12px;
    position: absolute;
    top: calc(50% - 6px);
    width: 12px;
  }
`;

const Left = Base.extend`
  left: -80px;

  &::after {
    right: 35px;
    transform: rotate(-45deg);
  }
`;

const Right = Base.extend`
  right: -80px;

  &::after {
    left: 35px;
    transform: rotate(135deg);
  }
`;

const Arrow = ({ onClick, side }) => {
  switch (side) {
    case 'left':
      return <Left onClick={onClick} />;
    case 'right':
      return <Right onClick={onClick} />;
    default:
      return <p>{`Unrecognized Value: ${side}`}</p>;
  }
};

Arrow.propTypes = {
  side: PropTypes.string.isRequired,
};

export default Arrow;



// WEBPACK FOOTER //
// ./src/pages/HomePage/BrandManifesto/Arrow.js